<!-- 企业级-平台运营-企业缴纳情况 -->
<template>
  <div class="mainArea CEnterprisePayment">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="staFlex">
        <div class="item alink" @click="toPlatpay">
          <div class="tit">
            <span>使用期限</span>
            <div class="toolTip" v-if="isToo1" @click.stop>
              您的平台使用期限即将过期，请点击此处文字进行缴费！
              <i class="el-icon-caret-bottom"></i>
              <em class="el-icon-error" @click="isToo1=false"></em>
            </div>
          </div>
          <div>{{platInfo.start_date}}~{{platInfo.end_date}}</div>
        </div>
        <div class="item">
          <span class="tit">平台使用费用</span>
          <div>
            {{platInfo.fee}}元/
            <template v-if="platInfo.fee_type==1">年</template>
            <template v-else-if="platInfo.fee_type==2">季度</template>
            <template v-else>月</template>
          </div>
        </div>
        <!-- <div class="item">
          <span class="tit">4G路由</span>
          <div>0.5G/1.2G</div>
        </div> -->
        <div class="item flex alink" @click="routeDio = true">
          <!-- <div class="item_1">
            <span class="tit">总流量</span>
            <div>120G</div>
          </div> -->
          <div class="item_1">
            <div class="tit">
              <span>总流量</span>
              <div class="toolTip toolEnd" v-if="isToo2" @click.stop>
                您有路由的使用期限即将过期，请点击此处文字查看详情！
                <i class="el-icon-caret-bottom"></i>
                <em class="el-icon-error" @click="isToo2 = false"></em>
              </div>
            </div>
            <div>{{platInfo.fourg_available_amount}}G</div>
          </div>
          <div class="item_1">
            <span class="tit">4G路由</span>
            <div>0个</div>
          </div>
        </div>
        <div class="item flex">
          <div class="item_1 alink" @click="toSmsrech">
            <div class="tit">
              <span>短信费率</span>
              <div class="toolTip toolEnd" v-if="isToo3" @click.stop>
                您的短信剩余条数不多，请点击此处文字进行充值！
                <i class="el-icon-caret-bottom"></i>
                <em class="el-icon-error" @click="isToo3 = false"></em>
              </div>
            </div>
            <div>{{platInfo.sms_fee}}元/条</div>
          </div>
          <div class="item_1">
            <span class="tit">已用条数</span>
            <div>{{platInfo.sms_total_amount-platInfo.sms_available_amount}}</div>
          </div>
          <div class="item_1 alink" @click="toSmsLog">
            <div class="tit">
              <span>剩余条数</span>
              <div class="toolTip toolEnd" v-if="isToo4" @click.stop>
                点击此处查看历史短信发送记录
                <el-checkbox v-model="isLogTips" @change="changeLogtips">不再提示</el-checkbox>
                <i class="el-icon-caret-bottom"></i>
                <em class="el-icon-error" @click="isToo4 = false"></em>
              </div>
            </div>
            <div>{{platInfo.sms_available_amount}}</div>
          </div>
        </div>
      </div>
      <div class="mainBodyContent">
        <div class="radSeach flex mb20">
          <div>
            <el-radio-group v-model="selSeach1" @change="getPlatformList(1)">
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">平台使用费</el-radio-button>
              <el-radio-button label="2">短信服务费</el-radio-button>
            </el-radio-group>
            <!-- <el-radio-group v-model="selSeach2">
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="1">待审核</el-radio-button>
              <el-radio-button label="2">已通过</el-radio-button>
              <el-radio-button label="3">已拒绝</el-radio-button>
            </el-radio-group> -->
          </div>
          <div>
            <el-button type="primary" @click="toBiling">开票资料</el-button>
          </div>
        </div>
        <div class="contTable">
          <el-table :data="payData" style="width: 100%" v-loading="loading">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="充值类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">平台使用费</span>
                <span v-else>短信服务费</span>
              </template>
            </el-table-column>
            <el-table-column label="充值金额">
              <template slot-scope="scope">{{scope.row.money}}元</template>
            </el-table-column>
            <el-table-column prop="operator_user" label="操作人"></el-table-column>
            <el-table-column label="开具发票需求">
              <template slot-scope="scope">
                <span v-if="scope.row.bill_flag == '1'">需要</span>
                <span v-else>不需要</span>
              </template>
            </el-table-column>
            <el-table-column label="是否付费">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_status == '1'">已支付</span>
                <span v-else>未支付</span>
              </template>
            </el-table-column>
            <el-table-column label="是否开具发票">
              <template slot-scope="scope">
                <template v-if="scope.row.bill_flag == '1'">
                  <span v-if="scope.row.had_bill == '1'">已开具</span>
                  <span v-else>未开具</span>
                </template>
                <template v-else>/</template>
              </template>
            </el-table-column>
            <el-table-column prop="pay_time" label="充值时间"></el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>1">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :page-count="total">
          </el-pagination>
        </div>
      </div>
      <!--路由信息-->
      <el-dialog title="路由信息" :visible.sync="routeDio" width="600px">
        <div class="cont_Dio">
          <el-table :data="routeData" style="width: 100%">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="" label="路由卡号"></el-table-column>
            <el-table-column prop="" label="路由期限"></el-table-column>
            <el-table-column prop="" label="流量"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast, updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { platformApi } from "../../../../static/js/api.js"

  export default {
    name: 'CEnterprisePayment',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        selSeach1:0,
        // selSeach2:0,

        isToo1:false,
        isToo2:true,
        isToo3:false,
        isToo4:true,
        isLogTips:false,
        platInfo:{},

        loading:false,
        payData:[],//充值数据
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        routeDio:false,//路由信息弹窗
        routeData:[],//路由信息
      }
    },
    mounted(){

    },
    created: async function () {
      var isLogTips = localStorage.getItem('isLogTips')
      if(isLogTips){
        if(isLogTips == 'true'){
          this.isToo4 = false
        }
      }
      this.getPlatformList()
    },
    methods: {
      //是否显示短信记录提示
      changeLogtips(){
        localStorage.setItem('isLogTips',this.isLogTips)
        if(this.isLogTips == true){
          this.isToo4 = false
        }
      },
      //获取缴费列表
      async getPlatformList(curr,limits){
        let that = this;
        this.loading = true;
        const dataObj = {
          'page': curr ? curr : that.curr,
          'perPage': limits ? limits : that.page,
          'type': that.selSeach1,
        }
        const res = await platformApi.getPlatformList(dataObj)
        if(res.meta.code == 200){
          if(res.data.company_config.sms_available_amount<=10){
            that.isToo3 = true
          }
          if(res.data.company_config.is_deadline==true){
            that.isToo1 = true
          }
          that.platInfo = res.data.company_config
          that.payData = res.data.pay_list
          that.total = parseInt(res.data.pageCount)
          that.loading = false
        }else{
          that.loading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getPlatformList(val)
      },
      //跳转到平台缴费
      toPlatpay(){
        sessionStorage.setItem('platInfo',JSON.stringify(this.platInfo))
        let navBarActive = [{function_tab: 'CPlatFormPay', function_name: '平台缴费'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/CPlatFormPay',
        })
      },
      //跳转到短信充值
      toSmsrech(){
        sessionStorage.setItem('platInfo',JSON.stringify(this.platInfo))
        let navBarActive = [{function_tab: 'CSMSRecharge', function_name: '短信充值'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/CSMSRecharge',
          query: {

          }
        })
      },
      //跳转到短信记录
      toSmsLog(){
        let that = this
        sessionStorage.setItem('platInfo',JSON.stringify(this.platInfo))
        let navBarActive = [{function_tab: 'CSMSLog', function_name: '短信记录'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/CSMSLog',
          query: {
            'sms_template': that.platInfo.sms_template,
          }
        })
      },
      //跳转到开票资料
      toBiling(){
        sessionStorage.setItem('platInfo',JSON.stringify(this.platInfo))
        let navBarActive = [{function_tab: 'CBillingInfo', function_name: '开票资料'}]
        // 更新面包屑内容
        updataBreadCrumb(3, navBarActive)
        this.$router.push({
          path: '/CBillingInfo',
          query: {

          }
        })
      },
      
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 303px);
//   overflow-y:auto; 
// }
.CEnterprisePayment{
  
  .mb20{ margin-bottom: 20px;}
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .staFlex{
    background: #fff;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    text-align: center;
    margin: 20px 30px 0;
    padding: 20px 0;
    .item{
      width: 25%;
      box-sizing:border-box;
      border-right:1px solid #ddd;
      color: #333;
      &:last-child{ border-right:none;}
      &.flex{
        display: flex;
        text-align: center;
        .item_1{
          width: 50%;
        }
      }
      .tit{
        font-size:14px;
        color: #888;
        display: block;
        margin-bottom: 6px;
        position: relative;
        .toolTip{
          position: absolute;
          top: -70px;
          left: 50%;
          margin-left: -40px;
          background: #303133;
          color: #fff;
          border-radius: 6px;
          padding: 10px;
          width: 200px;
          font-size: 12px;
          text-align: left;
          em{
            position: absolute;
            right: -5px;
            top: -5px;
            font-size: 14px;
          }
          i{
            position: absolute;
            bottom: -15px;
            font-size: 30px;
            left: 25px;
            color: #303133;
          }
          &.toolEnd{
            left: inherit;
            margin-left: 0;
            right: 50%;
            margin-right: -40px;
            i{
              left:inherit;
              right: 25px;
            }
          }
          
        }
      }
    }
  }
  .alink:hover{
    color: #409EFF;
    .tit{
      color: #409EFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CPlatformOperate/CEnterprisePayment.vue